export default __webpack_public_path__ + "static/hero-home-ec6b9eff6a39210629ab081f14caacbd.webp";